import React, { useRef } from 'react'
import { useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import Rails from '@rails/ujs'
import InputText from '../form/InputText'
import InputCheckbox from "../form/InputCheckbox";

const GREATER_OR_EQUAL_1 = 'Value must be greater than or equal to 1'
const MAXLENGTH_OR_EQUAL_MIN_LENGTH = 'Max Length must be greater than or equal to Max Length'
const NOT_EMPTY_FIELD = 'Can\'t be empty'

function SerialNumberConfig(props) {
    const { register, errors, getValues, trigger, watch } = useForm({
            defaultValues: props.config
        })
    const formRef = useRef()

    const snEnabled = !!watch("enabled")


    const handleSubmit = async (e) => {
        if(!snEnabled || await trigger()) {
            formRef.current.submit()
            e.target.disabled = true
        }
    }

    return <form action={`${props.action}`} method='POST'
                 ref={formRef}
                 className='flex flex-col p-2 font-light wizard-step-collapse-animation' autoComplete='off'>
        <input type='hidden' name='authenticity_token' value={Rails.csrfToken()}/>

        <InputCheckbox name='enabled' label='Enable Serial Number' ref={register()} value={true}/>
        <div className={`${snEnabled ? '': 'hidden'} mb-2`}>
            <InputText name='displayName'
                       label='Display Name'
                       ref={register({
                           required: {value: true, message: NOT_EMPTY_FIELD},
                       })}
                       error={errors?.displayName}
            />
            <label>Character Length</label>
            <div className='flex flex-row '>
                <div className='flex flex-row items-baseline flex-1 mr-2'>
                    <label className='mr-2' htmlFor='format.minLength'>Min</label>
                    <InputText className='flex-1'
                               name='format.minLength'
                               type='number'
                               ref={register({
                                   required: {value: true, message: NOT_EMPTY_FIELD},
                                   min: {
                                       value: 1,
                                       message: GREATER_OR_EQUAL_1
                                   }
                               })}
                               error={errors?.format?.minLength}
                    />
                </div>
                <div className='flex flex-row items-baseline flex-1'>
                    <label className='mr-2' htmlFor='format.maxLength'>Max</label>
                    <InputText className='flex-1'
                               name='format.maxLength'
                               type='number'
                               ref={register({
                                   required: {value: true, message: NOT_EMPTY_FIELD},
                                   min: {
                                       value: 1,
                                       message: GREATER_OR_EQUAL_1
                                   },
                                   validate: {
                                       greaterOrEqualToMin: value => Number(value) >= Number(getValues().format?.minLength) || <p>{MAXLENGTH_OR_EQUAL_MIN_LENGTH}</p>
                                   }
                               })}
                               error={errors?.format?.maxLength}
                    />
                </div>
            </div>
        </div>
        <div className={'flex flex-row-reverse'}>
            <button type='submit' onClick={(e) => {
                e.preventDefault()
                handleSubmit(e)
            }} className='btn-yellow w-38'>Save
            </button>
        </div>
    </form>
}

SerialNumberConfig.propTypes = {
    action: PropTypes.string,
    config: PropTypes.object
}

export default SerialNumberConfig
